import React from 'react'
import { Link } from 'react-router-dom'
import { TruncatedValue } from '../../../common/TruncatedValue'
import { BORDER, INK, MUTED } from '../core/consts'
import { RefusalClient, RefusalFact } from '../core/refusal.types'

/** Подпись слева, значение справа — строка фактов карточки без тикета. */
export const FactRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div className='d-flex align-items-baseline' style={{ gap: 12 }}>
    <div style={{ width: 132, flexShrink: 0, fontSize: 12.5, color: MUTED }}>{label}</div>
    <div style={{ flexGrow: 1, minWidth: 0, fontSize: 13, color: INK, wordBreak: 'break-word' }}>{children}</div>
  </div>
)

/**
 * Facts of a record that has no ticket: labelled pairs built by the backend. The client follows
 * the rule of every other surface — the merchant's own identifier, a link only from the token.
 */
const RefusalFacts: React.FC<{ title: string; facts: RefusalFact[]; client?: RefusalClient }> = ({ title, facts, client }) => (
  <div className='card'>
    <div className='d-flex align-items-center' style={{ minHeight: 56, padding: '0 24px', borderBottom: `1px solid ${BORDER}` }}>
      <h2 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: INK }}>{title}</h2>
    </div>
    <div className='d-flex flex-column' style={{ padding: '18px 24px', gap: 13 }}>
      {facts.map((fact) => (
        <FactRow key={fact.label} label={fact.label}>
          {/* Часть значений задаёт мерчант (transactionId, extraReturnParam) — сырыми не выводятся. */}
          <TruncatedValue value={fact.value} />
        </FactRow>
      ))}
      {client && (
        <FactRow label='Клиент'>
          {client.token ? (
            <Link to={'/client/info/' + client.token} className='text-primary' target='_blank'>
              <TruncatedValue value={client.externalId} focusable={false} />
            </Link>
          ) : (
            <TruncatedValue value={client.externalId} />
          )}
        </FactRow>
      )}
    </div>
  </div>
)

export default RefusalFacts
